import PicklistMetadata from "../PicklistMetadata";

// Bounded picklist of ALL company User Groups (display = Name, value = USID), sourced from the
// UserGroup EC (t5/v1/user_groups), realm-scoped. Used by the "Add Shared User Group" membership
// picker on the term Stewardship/Visibility tab — lists every company user group (unlike the
// memberships-only "UserGroup" picklist).
class UserGroupSharedPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "UserGroupShared";
        this.bounded = true;
        this.enterpriseComponent = "UserGroup";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        this.sortSpecification = [{"SortAttribute": "Name", "Direction": "DESC"}];
        this.static = false;
        this.typeField = "Name";
        this.typeValue = "USID";
        this.allowNoSelection = false;
    }
}

export default UserGroupSharedPicklistMetadata;
